import React from "react"
import { graphql, useStaticQuery } from "gatsby";
import Img from "gatsby-image";

function EasySection({ title, subtitle }) {
  const data = useStaticQuery(graphql`
  query {
    file(relativePath: { eq: "assets/settings.png" }) {
      childImageSharp {
        fluid(maxWidth: 520) {
          ...GatsbyImageSharpFluid
        }
      }
    }
  }
`)
  return (<div className="section section-screenshot">
    <div className="container">
      <h2>{title || "Choose when you want to be notified"}</h2>
      <div className="subtitle">{subtitle || <span>Get notified in realtime — or pick between daily, weekly & hourly click summaries.</span>}</div>
      <div className="section-image screenshot">
        <Img style={{ marginTop: "40px" }} fluid={data.file.childImageSharp.fluid} />
      </div>
    </div>
  </div>
  );
}

export default EasySection;